module.exports = __webpack_public_path__ + "img/linkedin.94025d95.svg";